export default "<div class=\"user-info\">\n    \n</div>"